type ProductGroup =
  | 'free'
  | 'pro'
  | 'guru'
  | 'business'
  | 'api access'
  | 'app center access'
  | null;

export const getProductGroup = async (): Promise<ProductGroup> => {
  try {
    const response = await fetch('/signup/i/product_group/');
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    return data?.result.toLowerCase();
  } catch (error) {
    console.error(error);
    return null;
  }
};
